import { objectWithoutProperties as _objectWithoutProperties, extends as _extends, objectSpread as _objectSpread } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { withContext, eventBus } from '@piggybank/core';
import { Consumer } from '../Field/context.js';
import pick from 'lodash/fp/pick';
import { TextInput } from '../TextInput/TextInput.js';
import isValidInteger from '../../utils/isValidInteger.js';

var leadsWithZero = function leadsWithZero(value) {
  return value.startsWith('0') && value.length > 1;
};

var NumberInput = React.forwardRef(function (_ref, ref) {
  var allowLeadingZeros = _ref.allowLeadingZeros,
      onChange = _ref.onChange,
      name = _ref.name,
      rest = _objectWithoutProperties(_ref, ["allowLeadingZeros", "onChange", "name"]);

  var handleChange = function handleChange(value, event) {
    eventBus.dispatch({
      type: 'onChange',
      component: 'NumberInput',
      value: value,
      name: name
    });
    onChange && onChange({
      value: value,
      event: event
    });
  };

  var handleNumberChange = function handleNumberChange(_ref2) {
    var value = _ref2.value,
        event = _ref2.event;

    if (value === '') {
      return handleChange('', event);
    }

    if (isValidInteger(value) && (allowLeadingZeros || !leadsWithZero(value))) {
      handleChange(value, event);
    }
  };

  return React.createElement(TextInput, _extends({
    name: name,
    "aria-label": "number input",
    onChange: handleNumberChange,
    pattern: "\\d*",
    type: "tel",
    ref: ref
  }, rest));
});
NumberInput.displayName = 'NumberInput';
NumberInput.defaultProps = {
  allowLeadingZeros: true
};
NumberInput.propTypes = process.env.NODE_ENV !== "production" ? _objectSpread({}, TextInput.propTypes, {
  allowLeadingZeros: PropTypes.bool
}) : {};
var NumberInput$1 = withContext(Consumer, pick(['name', 'value', 'onChange', 'onBlur', 'invalid', 'required', 'describers']))(NumberInput);
export default NumberInput$1;
export { NumberInput, leadsWithZero };